import styled from 'styled-components';
import { Button, LargeButton, MediumButton, SmallButton } from '@styles/button.styled';
import Arrow from '@components/svg-icons/arrow';

export const StyledButton = styled.button`
  ${Button}
`;

export const StyledSmallButton = styled.button`
  ${SmallButton}
`;

export const StyledMediumButton = styled.button`
  ${MediumButton}
`;

export const StyledLargeButton = styled.button`
  ${LargeButton}
`;

export const StyledArrow = styled(Arrow)`
  margin-left: 0.625rem;
`;
